import { render } from "./QuantumCareerChatbotTabs.vue?vue&type=template&id=6eed5811"
import script from "./QuantumCareerChatbotTabs.vue?vue&type=script&lang=js"
export * from "./QuantumCareerChatbotTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__